import React from 'react';
import styled from 'styled-components';

const StyledButton = styled.button<{
	variant?: 'primary' | 'secondary';
	disable?: boolean;
}>`
	display: flex;
	align-items: center;
	justify-content: center;
	border-radius: 40px;
	color: ${({ theme, variant }) =>
		variant === 'primary' ? theme.colors.white : variant === 'secondary' ? theme.colors.black : theme.colors.black};
	background: ${({ theme, variant }) =>
		variant === 'primary'
			? theme.colors.light_blue1
			: variant === 'secondary'
			? theme.colors.blue2
			: theme.colors.grey};
	padding: 0.5rem 2rem;
	font-size: 16px;
	line-height: 21px;
	font-weight: 600;
	border: none;
	outline: none;

	&:hover {
		opacity: 0.85;
	}

	${({ disable }) =>
		disable &&
		`
		opacity: 0.15 !important;
		cursor: not-allowed;
	`}
`;

export interface IButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
	variant?: 'primary' | 'secondary'; // primary as default
}

export const Button: React.FC<IButtonProps> = ({ children, disabled, onClick, ...props }) => {
	return (
		<StyledButton disable={disabled} onClick={e => onClick && !disabled && onClick(e)} {...props}>
			{children}
		</StyledButton>
	);
};
